import { render } from "./HiveTextCarousel.vue?vue&type=template&id=8c3d2a8a"
import script from "./HiveTextCarousel.vue?vue&type=script&lang=js"
export * from "./HiveTextCarousel.vue?vue&type=script&lang=js"
script.render = render

export default script